

import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Construction from "../pages/construction/page";
import Landscape from "../pages/landscape/page";
import Portfolio from "../pages/portfolio/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Login from "../pages/auth/login/page";
import Dashboard from "../pages/client/dashboard/page";
import Billing from "../pages/client/billing/page";
import ClientPortfolio from "../pages/client/portfolio/page";

// Webmail redirect component
const WebmailRedirect = () => {
  window.location.href = "https://gcam1195.siteground.biz/webmail/mail";
  return null;
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/construction",
    element: <Construction />,
  },
  {
    path: "/landscape",
    element: <Landscape />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/webmail",
    element: <WebmailRedirect />,
  },
  {
    path: "/client/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/client/billing",
    element: <Billing />,
  },
  {
    path: "/client/portfolio",
    element: <ClientPortfolio />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

